var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlow5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 65,
    viewBox: "0 0 51 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 33.8656V25.2501C1.25 18.8849 3.77858 12.7804 8.27947 8.27947C12.7804 3.77858 18.8849 1.25 25.2501 1.25C31.6153 1.25 37.7199 3.77858 42.2208 8.27947C46.7217 12.7804 49.2502 18.8849 49.2502 25.2501V33.8656M1.25 32.6348V49.8656H11.7116V29.5578H4.32694M49.2502 32.6348V49.8656H38.7886M38.7886 49.8656V29.5578H46.1733M38.7886 49.8656C38.7886 57.2503 33.8655 60.9426 24.6347 60.9426",
    stroke: "#12171C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6342 64.6347C26.6734 64.6347 28.3265 62.9815 28.3265 60.9423C28.3265 58.9031 26.6734 57.25 24.6342 57.25C22.595 57.25 20.9419 58.9031 20.9419 60.9423C20.9419 62.9815 22.595 64.6347 24.6342 64.6347Z",
    fill: "#FF6000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow5);
export default __webpack_public_path__ + "static/media/flow5.c3d134ff8bb1644a72a9d16d30026728.svg";
export { ForwardRef as ReactComponent };